import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";
import { Provider } from "react-redux";
import App from "./App";
import PersistedStore from "./store/index.js";
import reportWebVitals from "./reportWebVitals";

ReactGA.initialize("UA-169326204-6");

ReactDOM.render(
  // <Provider store={PersistedStore.getDefaultStore().store}>
  <Provider store={PersistedStore}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
